import { render, staticRenderFns } from "./CoozzyPadlockIcon.vue?vue&type=template&id=2aeb3183&scoped=true"
import script from "./CoozzyPadlockIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyPadlockIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeb3183",
  null
  
)

export default component.exports